<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <div v-if="$route.params.type == 'all-scheme'">
      <b-form-group label="Status">
        <b-form-checkbox
          v-for="option in statusOptions"
          :key="option.value"
          v-model="statusFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </div>

    <b-form-group
      label="Created Date"
    >
      <b-input-group>
        <flat-pickr
          v-model="startDateValue"
          class="form-control"
          placeholder="Select date range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    startDate: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      startDateValue: this.startDate,
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    startDate: {
      immediate: true,
      handler(val) {
        this.startDateValue = val
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:startDate', this.startDateValue)
      this.$emit('update:statusFilter', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.startDateValue = ''
      this.statusFilterValue = []
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:startDate', this.startDateValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>
